import React from 'react';
import { Button, Space, Tooltip } from 'antd';
import type { Mode } from '../hooks/usePWM202Mode';

interface ActionBarProps {
  mode: Mode;
  isEditing: boolean;
  hasPrev: boolean;
  hasNext: boolean;
  saving: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
  onAdd: () => void;
  onSave: () => void;
  onEdit: () => void;
  onRevert: () => void;
  onDelete: () => void;
  onLeave: () => void;
}

const ActionBar: React.FC<ActionBarProps> = ({
  mode, isEditing, hasPrev, hasNext, saving,
  canCreate, canEdit, canDelete,
  onFirst, onPrev, onNext, onLast,
  onAdd, onSave, onEdit, onRevert, onDelete, onLeave,
}) => {
  const browseMode = !isEditing;

  return (
    <div className="pwm202-action-bar">
      <Space wrap>
        {/* Navigation */}
        <Button size="small" disabled={!browseMode || !hasPrev} onClick={onFirst}>|&lt;</Button>
        <Button size="small" disabled={!browseMode || !hasPrev} onClick={onPrev}>&lt;</Button>
        <Button size="small" disabled={!browseMode || !hasNext} onClick={onNext}>&gt;</Button>
        <Button size="small" disabled={!browseMode || !hasNext} onClick={onLast}>&gt;|</Button>

        <span style={{ color: '#ccc' }}>|</span>

        {/* Add / Save */}
        <Tooltip title={!canCreate && browseMode ? '無新增權限' : ''}>
          <Button
            size="small"
            type={mode === 'add' ? 'primary' : 'default'}
            disabled={isEditing && mode !== 'add' ? true : !canCreate && browseMode}
            onClick={mode === 'add' ? onSave : onAdd}
          >
            {mode === 'add' ? '存檔' : '新增'}
          </Button>
        </Tooltip>

        {/* Edit / Revert */}
        <Tooltip title={!canEdit && browseMode ? '無修改權限' : ''}>
          <Button
            size="small"
            type={mode === 'edit' ? 'primary' : 'default'}
            disabled={(!canEdit && browseMode) || (mode === 'add')}
            onClick={mode === 'edit' ? onRevert : onEdit}
          >
            {mode === 'edit' ? '還原' : '修改'}
          </Button>
        </Tooltip>

        {/* Save during edit */}
        {mode === 'edit' && (
          <Button size="small" type="primary" loading={saving} onClick={onSave}>
            存檔
          </Button>
        )}

        {/* Delete */}
        <Tooltip title={!canDelete ? '無刪除權限' : ''}>
          <Button
            size="small"
            danger
            disabled={!canDelete || isEditing}
            onClick={onDelete}
          >
            刪除
          </Button>
        </Tooltip>

        <span style={{ color: '#ccc' }}>|</span>

        {/* Leave */}
        <Button size="small" onClick={onLeave}>離開</Button>
      </Space>
    </div>
  );
};

export default ActionBar;
